import React from "react";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
import routes from "routes";
import footerRoutes from "footer.routes";
import TabelaArtigos from "./TabelaArtigos";
import '@fortawesome/fontawesome-free/css/all.min.css';

function Artigos() {
  return (
    <>
      <DefaultNavbar routes={routes} sticky />
      <TabelaArtigos />
      <DefaultFooter content={footerRoutes} />
    </>
  );
}

export default Artigos;
